type TRoute = {
	readonly path: string;
	readonly file: string;
	readonly subroutes?: Readonly<Record<string, TRoute>>;
};

export const routesConfig = {
	index: {
		path: '',
		file: 'routes/index/index.tsx',
	},
	aboutClearGroup: {
		path: 'about-clear-group',
		file: 'routes/about-clear-group/about-clear-group.tsx',
	},
	imprint: {
		path: 'imprint',
		file: 'routes/imprint/imprint.tsx',
	},
	dataProtectionAct: {
		path: 'data-protection-act',
		file: 'routes/data-protection-act/data-protection-act.tsx',
	},
	howToCite: {
		path: 'how-to-cite',
		file: 'routes/how-to-cite/how-to-cite.tsx',
	},
	propertyViewer: {
		path: 'property-viewer',
		file: 'routes/property-viewer/property-viewer.tsx',
	},
	propertyCalculator: {
		path: 'property-calculator/refractive-index',
		file: 'routes/property-calculator/property-calculator.tsx',
	},
} as const satisfies Readonly<Record<string, TRoute>>;
